import Loadable from 'react-loadable';
import Loading from '../app/wajujogido/Loading/Loading';
import { MAX_TIMEOUT_LOADABLE } from '../constants/constants';
import { URL } from './urlLibrary';

export const modules = {
  home: () => import('../pages/Home/HomePage'),
  register: () => import('../pages/Register/RegisterPage'),
  main: () => import('../pages/Main/MainPage'),
  academies: () => import('../pages/Academies/AcademiesPage'),
  usuarios: () => import('../pages/Usuarios/UsuariosPage'),
  materias: () => import('../pages/Materias/MateriasPage'),
  examenes: () => import('../pages/Examenes/ExamenesPage'),
  buscadorpreguntas: () => import('../pages/BuscadorPreguntas/BuscadorPreguntasPage'),
  foros: () => import('../pages/Foros/ForosPage'),
  realizarExamenRapido: () => import('../pages/RealizarExamenRapido/RealizarExamenRapidoPage'),
  realizarExamenReal: () => import('../pages/RealizarExamenReal/RealizarExamenRealPage'),
  realizarExamenSimulacro: () => import('../pages/RealizarExamenSimulacro/RealizarExamenSimulacroPage'),
  realizarExamenErroneas: () => import('../pages/RealizarExamenErroneas/RealizarExamenErroneasPage'),
  examen: () => import('../pages/Examen/ExamenPage'),
  userSetup: () => import('../pages/UserSetup/UserSetupPage'),
  counter: () => import('../pages/Counter/CounterPage'),
  file: () => import('../pages/File/FilePage'),
  404: () => import('../pages/PageNotFound/PageNotFound'),
  sessionExpired: () => import('../pages/SessionExpired/SessionExpiredPage')
}

export const pageList = {
  home: {
    ...URL.home,
    exact: true,
    component: Loadable({
      loader: modules.home,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  register: {
    ...URL.register,
    exact: true,
    component: Loadable({
      loader: modules.register,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  main: {
    ...URL.main,
    exact: true,
    component: Loadable({
      loader: modules.main,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  academies: {
    ...URL.academies,
    exact: true,
    component: Loadable({
      loader: modules.academies,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
    },
    usuarios: {
        ...URL.usuarios,
        exact: true,
        component: Loadable({
            loader: modules.usuarios,
            loading: Loading,
            timeout: MAX_TIMEOUT_LOADABLE,
        }),
    },
    materias: {
        ...URL.materias,
        exact: true,
        component: Loadable({
            loader: modules.materias,
            loading: Loading,
            timeout: MAX_TIMEOUT_LOADABLE,
        }),
    },
    examenes: {
      ...URL.examenes,
      exact: true,
      component: Loadable({
          loader: modules.examenes,
          loading: Loading,
          timeout: MAX_TIMEOUT_LOADABLE,
      }),
    },
    buscadorpreguntas: {
        ...URL.buscadorpreguntas,
        exact: true,
        component: Loadable({
            loader: modules.buscadorpreguntas,
            loading: Loading,
            timeout: MAX_TIMEOUT_LOADABLE,
        }),
    },
    foros: {
        ...URL.foros,
        exact: true,
        component: Loadable({
            loader: modules.foros,
            loading: Loading,
            timeout: MAX_TIMEOUT_LOADABLE,
        }),
    },
    realizarExamenRapido: {
      ...URL.realizarExamenRapido,
      exact: true,
      component: Loadable({
        loader: modules.realizarExamenRapido,
        loading: Loading,
        timeout: MAX_TIMEOUT_LOADABLE,
      }),
    },
    realizarExamenReal: {
      ...URL.realizarExamenReal,
      exact: true,
      component: Loadable({
        loader: modules.realizarExamenReal,
        loading: Loading,
        timeout: MAX_TIMEOUT_LOADABLE,
      }),
    },
    realizarExamenSimulacro: {
      ...URL.realizarExamenSimulacro,
      exact: true,
      component: Loadable({
        loader: modules.realizarExamenSimulacro,
        loading: Loading,
        timeout: MAX_TIMEOUT_LOADABLE,
      }),
    },
    realizarExamenErroneas: {
      ...URL.realizarExamenErroneas,
      exact: true,
      component: Loadable({
        loader: modules.realizarExamenErroneas,
        loading: Loading,
        timeout: MAX_TIMEOUT_LOADABLE,
      }),
    },
    examen: {
        ...URL.examen,
        exact: true,
        component: Loadable({
            loader: modules.examen,
            loading: Loading,
            timeout: MAX_TIMEOUT_LOADABLE,
        }),
    },
  userSetup: {
    ...URL.userSetup,
    exact: true,
    component: Loadable({
      loader: modules.userSetup,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  counter: {
    ...URL.counter,
    exact: true,
    component: Loadable({
      loader: modules.counter,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  file: {
    ...URL.file,
    exact: true,
    component: Loadable({
      loader: modules.file,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  404: {
    ...URL['404'],
    exact: true,
    component: Loadable({
      loader: modules[404],
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  sessionExpired: {
    ...URL.sessionExpired,
    exact: true,
    component: Loadable({
      loader: modules.sessionExpired,
      loading: Loading,
      timeout: MAX_TIMEOUT_LOADABLE,
    }),
  },
  redirectNotFound: {
    ...URL.redirectNotFound,
    exact: false,
    to: '/404',
  },
}
